<template>
  <div style="white-space: normal">
    <v-layout column>
      <v-flex xs12>
        <v-layout>
          <!-- <v-flex xs4 class="pa-1">
            <v-btn block color="primary" @click="_cbDownloadSMB" :loading="this.loading">
              <v-icon left>mdi-file-download</v-icon>
              Executie
            </v-btn>
          </v-flex>
          <v-flex xs4 class="pa-1">
            <v-btn block color="primary" @click="_cbDownloadEvolutie" :loading="this.loading">
              <v-icon left>mdi-file-download</v-icon>
              Evolutie
            </v-btn>
          </v-flex> -->
          <v-flex xs12 class="pa-1">
            <v-btn block color="secondary" @click="_cbDownloadDate" :loading="this.loading">
              <v-icon left>mdi-download</v-icon>
              Baza de date
            </v-btn>
          </v-flex>
        </v-layout>
        <v-alert
          v-model="error"
          type="error"
          dismissible>
          A aparut o eroare la procesarea cererii...
        </v-alert>
      </v-flex>
      <v-flex xs12>
        <v-card flat>
          <v-card-title primary-title class="pb-0 pt-0" style="justify-content: center">
            <div>
              <v-tabs
                v-if="tabs.length"
                hide-slider
                color="transparent"
                slider-color="accent"
                class="ml-2 ob-section-tabs pb-0"
                show-arrows
                v-model="selectedTabIdentifier"
                :key="tabsUpdate">
                <v-tab
                  v-for="item in tabs"
                  :key="item._id"
                  @click="_cbSelectTab(item._id)"
                  :ref="`tab-${item._id}`">
                  {{ item.label }}
                </v-tab>
              </v-tabs>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs4>
        <v-card flat>
          <v-card-title primary-title class="pb-0">
            <div>
              <div class="subheading">Formule</div>
              <p v-if="!formule.length">Nu exista date...</p>
            </div>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-list v-if="!loading" class="pt-0" dense>
              <template v-for="item in formule">
                <v-list-tile
                  :key="item._id"
                  v-if="item.formula"
                  @click="_cbSelectFormula(item)"
                  :color="selectedFormula && selectedFormula._id === item._id ? 'accent' : ''">
                  <v-list-tile-action>
                    <!-- <v-icon color="primary">mdi-function-variant</v-icon> -->
                    {{item.cod}}
                  </v-list-tile-action>
                  <v-list-tile-title>{{item.label}}</v-list-tile-title>
                  <v-list-tile-action style="flex-direction: row; align-items: center; justify-content: flex-end;">
                    <v-icon v-if="+item.value === 1" color="green" small>mdi-check</v-icon>
                    <v-icon v-else color="red" small>mdi-close</v-icon>
                    <v-icon :style="{visibility: selectedFormula && selectedFormula._id === item._id ? 'visible' : 'hidden'}">mdi-menu-right</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-divider inset vertical class="ma-0"></v-divider>
      <v-flex xs4>
        <v-card flat>
          <v-card-title primary-title class="pb-0">
            <div>
              <div class="subheading">Detalii Formula</div>
            </div>
          </v-card-title>
          <v-card-text class="pt-0">
            <template v-if="selectedFormula">
              <div>
                <v-subheader class="pl-0">{{selectedFormula.label}}</v-subheader>
                <var class="pl-2 d-block">{{selectedFormula.explicatie}}</var>
              </div>
              <div>
                <v-subheader class="pl-0">Formula</v-subheader>
                <var class="pl-2 mb-4 d-block">{{selectedFormula.formula}}</var>
                <var class="pl-2 d-block">
                </var>
              </div>
              <!-- <v-list dense class="pt-0 ob-list-tight" two-line>
                <v-subheader class="pl-0">Variabile</v-subheader>
                <template v-for="(varValue, varKey) in selectedFormula.variabile">
                  <v-list-tile :key="varKey + varValue + '_formula'">
                    <v-list-tile-action>
                      <v-icon color="primary">mdi-variable</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{varKey}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{varValue | number}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider :key="varKey + varValue + '_divider'"></v-divider>
                </template>
              </v-list> -->
            </template>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-divider inset vertical class="ma-0"></v-divider>
      <v-flex xs4>
        <v-card flat>
          <v-card-title primary-title class="pb-0">
            <div>
              <div class="subheading">Variabile Formula</div>
            </div>
          </v-card-title>
          <v-card-text class="pa-0">
            <template v-if="selectedFormula">
              <v-list dense class="ob-list-tight" two-line>
                <template v-for="(varValue, varKey) in selectedFormula.variabile">
                  <v-list-tile :key="varKey + varValue + '_formula'">
                    <v-list-tile-action>
                      <v-icon color="primary">mdi-variable</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{varKey}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{varValue | number}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider :key="varKey + varValue + '_divider'"></v-divider>
                </template>
              </v-list>
            </template>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row v-if="selectedFormula">
      <v-flex xs12>
        <v-card flat>
          <v-card-title primary-title class="pb-0 pt-0" style="justify-content: center">
            <div>
              <div class="subheading">Formula interpretata</div>
            </div>
          </v-card-title>
          <v-card-text>
            <vue-mathjax v-if="selectedFormula"
              :formula="selectedFormula.prettyFormula"
              :ref="`jax`">
            </vue-mathjax>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
// import { createWriteStream } from 'streamsaver'

export default {
  name: 'verificare-apl',
  props: {
    _id: {
      type: String,
      required: true
    },
    cifop: {
      type: String,
      required: true
    },
    cifos: {
      type: String,
      required: true
    },
    perioada: {
      type: String,
      required: true
    },
    denumire: {
      type: String,
      required: true
    },
    judet: {
      type: String,
      required: true
    }
  },
  data: () => ({
    type: 'verificareApl',
    selectedTabIdentifier: null,
    tabsUpdate: 1,
    selectedFormula: null,
    error: false
  }),
  computed: {
    host () {
      return this.$store.getters.host
    },
    anTrimestru () {
      return this.perioada.split('-').map((section, index) => {
        return index === 0 ? section : section[1]
      })
    },
    tabs () {
      return this.$store.getters[`${this.type}/tabs`]
    },
    formule () {
      return this.$store.getters[`${this.type}/items`]
    },
    total () {
      return this.$store.getters[`${this.type}/total`]
    },
    selectedTab () {
      return this.$store.getters[`${this.type}/selectedTab`]
    },
    selectedTabID () {
      return this.$store.getters[`${this.type}/selectedTabID`]
    },
    loading () {
      return this.$store.getters[`${this.type}/loading`]
    },
    token () {
      return this.$store.getters['token']
    }
    // pagination: {
    //   get () {
    //     return this.$store.getters[`${this.type}/pagination`]
    //   },
    //   set (pagination) {
    //     const { sortBy, descending, page, rowsPerPage } = pagination
    //     this.$store.dispatch(`${this.type}/paginationChanged`, { sortBy, descending, page, rowsPerPage })
    //   }
    // }
  },
  watch: {
    tabs () {
      this.forceTabsUpdate()
    },
    selectedTab: {
      immediate: true,
      handler () {
        this.$nextTick(() => {
          if (this.$refs[`tab-${this.selectedTabID}`]) {
            this.$nextTick(() => {
              this.$refs[`tab-${this.selectedTabID}`][0].click()
            })
          }
        })
      }
    },
    selectedTabID: {
      immediate: true,
      handler () {
        this.$nextTick(() => {
          if (this.$refs[`tab-${this.selectedTabID}`]) {
            this.$nextTick(() => {
              this.$refs[`tab-${this.selectedTabID}`][0].click()
            })
          }
        })
      }
    },
    items (v) {
      // setTimeout(() => {
      //   if (this.$refs.jax) {
      //     this.$refs.jax.forEach(comp => {
      //       comp.renderMathJax()
      //     })
      //   }
      // }, 2000)
    }
  },
  methods: {
    _cbDownloadDate () {
      this.$store.commit(`${this.type}/setLoading`, true)
      fetch(`${this.host}/getdate?cifop=${this.cifop}&cifos=${this.cifos}&an=${this.anTrimestru[0]}&trimestru=${this.anTrimestru[1]}`, {
        method: 'get',
        headers: new Headers({
          'Authorization': this.token
        })
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Server error...')
          }
          return response.blob()
        })
        .then(blob => {
          this.$store.commit(`${this.type}/setLoading`, false)
          var url = window.URL.createObjectURL(blob)
          var a = document.createElement('a')
          a.href = url
          a.download = `VerdeFIN_DATE_${this.cifop}_${this.cifos}_${this.anTrimestru[0]}_T${this.anTrimestru[1]}.xlsx`
          document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click()
          a.remove() // afterwards we remove the element again
        })
        .catch(err => {
          this.error = true
          this.$store.commit(`${this.type}/setLoading`, false)
          console.log(err)
        })
    },
    // _cbDownloadSMB () {
    //   const perioade = [`${this.anTrimestru[0]}-T${this.anTrimestru[1]}`]
    //   this.$store.commit(`${this.type}/setLoading`, true)
    //   fetch(`${this.host}/smb-client?cifop=${this.cifop}&cifos=${this.cifos}&&perioade=${JSON.stringify(perioade)}`, {
    //     method: 'get',
    //     headers: new Headers({
    //       'Authorization': this.token
    //     })
    //   })
    //     .then(res => {
    //       const fileStream = createWriteStream(`TUDs_Analytics_Executie_${this.cifop}_${this.denumire}_${this.judet}.zip`)
    //       this.$store.commit(`${this.type}/setLoading`, false)

    //       // more optimized
    //       if (res.body.pipeTo) {
    //         return res.body.pipeTo(fileStream)
    //       }

    //       const writer = fileStream.getWriter()
    //       const reader = res.body.getReader()
    //       const pump = () => reader.read().then(({ value, done }) => {
    //         if (done) {
    //           // close the stream so we stop writing
    //           writer.close()
    //           this.$store.commit(`${this.type}/setLoading`, false)
    //         } else {
    //           // Write one chunk, then get the next one
    //           writer.write(value).then(pump)
    //         }
    //       })

    //       // Start the reader
    //       pump().then(() => {
    //         this.$store.commit(`${this.type}/setLoading`, false)
    //         console.log('Closed the stream, Done writing')
    //       })
    //     })
    //     // .then(response => {
    //     //   if (!response.ok) {
    //     //     throw new Error('Server error...')
    //     //   }
    //     //   return response.blob()
    //     // })
    //     // .then(blob => {
    //     //   this.$store.commit(`${this.type}/setLoading`, false)
    //     //   var url = window.URL.createObjectURL(blob)
    //     //   var a = document.createElement('a')
    //     //   a.href = url
    //     //   a.download = `VerdeFIN_SMB_${this.cifop}_${this.cifos}_${this.anTrimestru[0]}_T${this.anTrimestru[1]}.zip`
    //     //   document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
    //     //   a.click()
    //     //   a.remove() // afterwards we remove the element again
    //     // })
    //     .catch(err => {
    //       this.error = true
    //       this.$store.commit(`${this.type}/setLoading`, false)
    //       console.log(err)
    //     })
    // },
    // _cbDownloadEvolutie () {
    //   const perioade = [`${this.anTrimestru[0]}-T${this.anTrimestru[1]}`]
    //   this.$store.commit(`${this.type}/setLoading`, true)
    //   fetch(`${this.host}/evolutie-client?cifop=${this.cifop}&cifos=${this.cifos}&perioade=${JSON.stringify(perioade)}`, {
    //     method: 'get',
    //     headers: new Headers({
    //       'Authorization': this.token
    //     })
    //   })
    //     .then(res => {
    //       const fileStream = createWriteStream(`TUDs_Analytics_Evolutie_${this.cifop}_${this.denumire}_${this.judet}.zip`)
    //       this.$store.commit(`${this.type}/setLoading`, false)

    //       // more optimized
    //       if (res.body.pipeTo) {
    //         return res.body.pipeTo(fileStream)
    //       }

    //       const writer = fileStream.getWriter()
    //       const reader = res.body.getReader()
    //       const pump = () => reader.read().then(({ value, done }) => {
    //         if (done) {
    //           // close the stream so we stop writing
    //           writer.close()
    //           this.$store.commit(`${this.type}/setLoading`, false)
    //         } else {
    //           // Write one chunk, then get the next one
    //           writer.write(value).then(pump)
    //         }
    //       })

    //       // Start the reader
    //       pump().then(() => {
    //         this.$store.commit(`${this.type}/setLoading`, false)
    //         console.log('Closed the stream, Done writing')
    //       })
    //     })
    //     // .then(response => {
    //     //   if (!response.ok) {
    //     //     throw new Error('Server error...')
    //     //   }
    //     //   return response.blob()
    //     // })
    //     // .then(blob => {
    //     //   this.$store.commit(`${this.type}/setLoading`, false)
    //     //   var url = window.URL.createObjectURL(blob)
    //     //   var a = document.createElement('a')
    //     //   a.href = url
    //     //   a.download = `VerdeFIN_SMB_${this.cifop}_${this.cifos}_${this.anTrimestru[0]}_T${this.anTrimestru[1]}.zip`
    //     //   document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
    //     //   a.click()
    //     //   a.remove() // afterwards we remove the element again
    //     // })
    //     .catch(err => {
    //       this.error = true
    //       this.$store.commit(`${this.type}/setLoading`, false)
    //       console.log(err)
    //     })
    // },
    _cbSelectFormula (formula) {
      this.$set(this, 'selectedFormula', formula)
      setTimeout(() => {
        if (this.$refs.jax) {
          this.$refs.jax.renderMathJax()
        }
      }, 500)
    },
    _cbSelectTab (id) {
      this.selectedFormula = null
      this.$store.dispatch(`${this.type}/setSelectedTab`, id)
    },

    forceTabsUpdate () {
      this.tabsUpdate++
    }
  },
  created () {
    // created/destroyed get called each time the row expands/collapses
    this.$store.commit(`${this.type}/setAplID`, this._id)
    this.$store.commit(`${this.type}/setAplCifs`, { cif_op: this.cifop, cif_os: this.cifos })
    this.$store.commit(`${this.type}/setAnTrimestru`, this.anTrimestru)
    this.$store.dispatch(`${this.type}/setEventWatchers`)
    this.$store.dispatch(`${this.type}/fetchItems`)
  },
  destroyed () {
    this.$store.commit(`${this.type}/clearState`)
  }
}
</script>
